import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    urlDesktop: 'https://app.socialdoctor.io',
    urlAndroid: 'https://play.google.com/store/apps/details?id=io.social.doctor.app',
    urlIos: 'https://apps.apple.com/app/social_doctor_app/id1527235671',
    gaCode: 'UA-174593404-1',
    pxCode: 'AW-606788029',
    fbCode: '445349919783509'
  },
  getters: {
    getDeviceType: () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera
      if (/android/i.test(userAgent)) {
        return 'Android'
      }

      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS'
      }

      return 'Desktop'
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js